import { createAction } from "actions/createAction";
import { CALLS_SET_ITEMS, CALLS_SET_FILTERS } from "const/actionTypes";
import { AnyAction } from "@reduxjs/toolkit";
import { formatLocalDateNoMs } from "utils";
import { toBackendUTCString, lastMinutesToEndOfDayUTC } from "utils/time";

export interface CallItem {
    call_id: string;
    time: string;
    ip_src: string;
    ip_dst: string;
    type: string;
    number_from: string;
    number_to: string;
    packets_count: number;
    session_time: string;
};

export interface CallsState {
    filters: {
        [key: string]: any;
    };
};

export interface PacketItem {
    packet_id: string;
    ip_src: string;
    ip_dst: string;
    method_code: string;
};

// export const setCallsItems = createAction<CallItem[]>(CALLS_SET_ITEMS);

// Initial state
const { from, to } = lastMinutesToEndOfDayUTC(5);

const initialState: CallsState = {
    filters: {
        time_from: toBackendUTCString(from),
        time_to: toBackendUTCString(to),
        number_from: "",
        number_to: "",
        ip_src: "",
        ip_dst: "",
        call_id: "",
        method_code: ""
    }
};


const handlers = {
    [CALLS_SET_FILTERS]: (state: CallsState, action: AnyAction) => ({
        ...state,
        filters: {
            ...state.filters,
            ...action.payload
        }
    }),
    DEFAULT: (state: CallsState) => state
} as const;

// Reducer
const callsReducer = (state = initialState, action: AnyAction) => {
    const handle = handlers[action.type as keyof typeof handlers] || handlers.DEFAULT;
    return handle(state, action as any);
};

export default callsReducer; 